import * as angular from 'angular';
import {
    FeatureToggles,
    FeatureTogglesResource
} from 'angular/resources/feature-toggles.resource';
import * as moment from 'pkp-moment-timezone-all-years';
import { UtilService } from 'app/_services/util.service';

class NetworkPointDetailsOperatorInfoValidityComponentCtrl
    implements ng.IController
{
    isCreateMode: boolean;
    isEditMode: boolean;
    validityExpanded: boolean = true;
    networkPoint: NetworkPointDto;
    minDate: number;
    featureToggles: FeatureToggles;
    form: ng.IFormController;

    constructor(
        private utilService: UtilService,
        private featureTogglesResource: FeatureTogglesResource,
        private $scope: angular.IScope
    ) {}

    $onInit(): void {
        this.featureTogglesResource.getUrls().subscribe((featureToggles) => {
            this.featureToggles = featureToggles;

            if (this.isCreateMode) {
                this.minDate = moment(Date.now()).valueOf();
                this.networkPoint.validity0.start = moment(
                    this.minDate
                ).toDate();
            }
        });
    }

    setTimeForFutureDates(): void {
        if (!moment().isSame(this.networkPoint.validity0.start, 'day')) {
            this.networkPoint.validity0.start = moment(
                this.networkPoint.validity0.start
            )
                .hours(6)
                .minutes(0)
                .seconds(0)
                .milliseconds(0)
                .toDate();
        } else {
            this.networkPoint.validity0.start = moment(this.minDate).toDate();
        }
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoValidity', {
    controller: NetworkPointDetailsOperatorInfoValidityComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-validity.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
